(() => {
  const items = document.querySelectorAll('.project-story__feature, .project-story__chapter, .project-impact__card, .project-trust__card, .mission-pillar');

  if (items.length) {
    items.forEach((item, index) => item.style.setProperty('--reveal-delay', `${Math.min(index * 70, 420)}ms`));

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      items.forEach((item) => observer.observe(item));
    }
  }

  const productInfo = document.querySelector('product-info');
  const donationForm = document.querySelector('#donation-form');
  const impactCards = document.querySelectorAll('[data-impact-amount]');
  const donationJumps = document.querySelectorAll('[data-donation-jump]');

  const scrollToProjectStart = () => {
    if (!productInfo) return;
    const scrollTarget = document.querySelector('#project-donation-panel') || productInfo;
    const stickyHeader = document.querySelector('sticky-header, .section-header');
    const headerOffset = stickyHeader ? Math.min(stickyHeader.getBoundingClientRect().height, 120) : 80;
    const targetTop = Math.max(0, scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset - 12);
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  };

  const normalizeAmount = (value) => {
    const numeric = Number((value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(numeric) ? numeric.toFixed(2) : '';
  };

  const chooseVariant = (card) => {
    const targetAmount = normalizeAmount(card.dataset.impactAmount);
    const directVariantId = card.dataset.impactVariantId;
    const optionValue = card.dataset.impactOptionValue;
    const variantInput = donationForm.querySelector('input[name="id"], input.product-variant-id');
    const options = productInfo.querySelectorAll('.product-form__input--pill input[type="radio"]');
    const matchedOption = Array.from(options).find((option) => {
      const label = option.id ? document.querySelector(`label[for="${option.id}"]`) : option.nextElementSibling;
      return option.value === optionValue || normalizeAmount(option.value) === targetAmount || normalizeAmount(label?.textContent) === targetAmount;
    });

    if (matchedOption) {
      matchedOption.click();
      matchedOption.focus({ preventScroll: true });
    } else if (directVariantId && variantInput) {
      variantInput.value = directVariantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    scrollToProjectStart();
    window.setTimeout(scrollToProjectStart, 500);
    window.setTimeout(() => donationForm.querySelector('input, button')?.focus({ preventScroll: true }), 650);
  };

  if (productInfo && donationForm && impactCards.length) {
    impactCards.forEach((card) => card.addEventListener('click', () => chooseVariant(card)));
  }

  if (productInfo && donationJumps.length) {
    donationJumps.forEach((jump) => jump.addEventListener('click', (event) => {
      event.preventDefault();
      scrollToProjectStart();
      window.setTimeout(scrollToProjectStart, 500);
    }));
  }

  // Seal Subscriptions injects this legal disclosure after the donation controls.
  // Keep the recurring purchase logic intact, but hide only the disclosure copy
  // requested for this donation-focused storefront.
  const recurringTermsPrefix = 'this item is a deferred, subscription, or recurring purchase';
  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const hideRecurringTerms = () => {
    const scope = document.querySelector('.project-product-section') || productInfo || document;
    const candidates = Array.from(scope.querySelectorAll('p, div, small, span'));

    candidates.forEach((element) => {
      if (element.dataset.charityHiddenRecurringTerms === 'true') return;

      const text = normalizeText(element.textContent);
      if (!text.startsWith(recurringTermsPrefix) || text.length > 520) return;

      const childContainsTerms = Array.from(element.children).some((child) => {
        const childText = normalizeText(child.textContent);
        return childText.startsWith(recurringTermsPrefix);
      });

      if (childContainsTerms) return;

      element.dataset.charityHiddenRecurringTerms = 'true';
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
    });
  };

  const hideRedundantSubscriptionInterval = () => {
    const scope = document.querySelector('.sealsubs-target-element');
    if (!scope) return;

    Array.from(scope.querySelectorAll('span, small, p, div')).forEach((element) => {
      if (element.children.length || element.dataset.charityHiddenInterval === 'true') return;
      const text = normalizeText(element.textContent);
      const parentText = normalizeText(element.parentElement?.textContent);
      const isDuplicate = text === 'monthmonth' || (text === 'month' && parentText.includes('lasting hope'));
      if (!isDuplicate) return;
      element.dataset.charityHiddenInterval = 'true';
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
    });
  };

  if (productInfo) {
    hideRecurringTerms();
    hideRedundantSubscriptionInterval();
    const recurringTermsObserver = new MutationObserver(() => {
      hideRecurringTerms();
      hideRedundantSubscriptionInterval();
    });
    recurringTermsObserver.observe(productInfo, { childList: true, subtree: true, characterData: true });
  }

  const smallGiftModal = document.querySelector('[data-small-gift-modal]');
  if (smallGiftModal) {
    let exitOfferShown = false;
    let exitOfferArmed = false;
    let pageWasHidden = false;
    let previouslyFocused = null;

    const armExitOffer = () => {
      exitOfferArmed = true;
    };

    const closeExitOffer = () => {
      smallGiftModal.hidden = true;
      document.body.classList.remove('small-gift-modal-open');
      previouslyFocused?.focus?.({ preventScroll: true });
    };

    const openExitOffer = () => {
      if (!exitOfferArmed || exitOfferShown || smallGiftModal.hidden === false) return;
      exitOfferShown = true;
      previouslyFocused = document.activeElement;
      smallGiftModal.hidden = false;
      document.body.classList.add('small-gift-modal-open');
      smallGiftModal.querySelector('.small-gift-modal__dialog')?.focus({ preventScroll: true });
    };

    window.setTimeout(armExitOffer, 1500);
    ['pointerdown', 'keydown', 'scroll'].forEach((eventName) => {
      document.addEventListener(eventName, armExitOffer, { once: true, passive: eventName === 'scroll' });
    });

    smallGiftModal.querySelectorAll('[data-small-gift-close]').forEach((control) => control.addEventListener('click', closeExitOffer));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && smallGiftModal.hidden === false) closeExitOffer();
    });

    document.addEventListener('mouseout', (event) => {
      const leavingDocument = !event.relatedTarget && !event.toElement;
      if (leavingDocument && event.clientY <= 24) openExitOffer();
    });

    window.addEventListener('blur', () => {
      window.setTimeout(() => {
        if (document.activeElement?.tagName === 'IFRAME') return;
        openExitOffer();
      }, 0);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        pageWasHidden = true;
        return;
      }

      if (pageWasHidden) {
        pageWasHidden = false;
        openExitOffer();
      }
    });
  }
})();
